import { ToggleGroup, ToggleGroupEvents, ToggleGroupItemSelectedEventData } from "../../../ui/ToggleGroup";
import { RectSize } from "../../../utils/RectSize";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { LayoutDataManager } from "../../managers/LayoutDataManager";
import { AppSettings } from "../../managers/AppSettings";
import { AppObjectPool } from "../../pooling/AppObjectPool";
import { OptionsLeafPopupContentBase } from "./OptionsLeafPopupContentBase";
import { OptionsLeafPopupTextItem } from "./OptionsLeafPopupTextItem";


/**
 * Content of popup containing paragraph of text
 */
export class OptionsLeafPopupTextItemsContent
    extends OptionsLeafPopupContentBase {
    protected itemSpacingBase: RectSize = new RectSize(0, 40);
    protected itemSpacing: RectSize = new RectSize();
    protected toggleGroup: ToggleGroup;
    private itemPoolGroupKey: string = "OptionsLeafPopupTextItem";


    public override Init(cullItems: boolean = true, onBtnBackClick: Function): void {
        super.Init(cullItems, onBtnBackClick);

        this.itemSpacing.CopyFrom(this.itemSpacingBase);
        this.toggleGroup = new ToggleGroup();
    }

    public override Build(): void {
        // > bg
        super.Build();

        // add items in @see SetData
    }

    /**
     * Data has been set. 
     * REBUILD view.
     * 
     * Exec order
     * > parent(OptionsLeafPopup)::SetData
     *   > this::SetData
     *     > parent
     */
    public override UpdateFromData(): void {
        // console.log("UpdateFromData");

        // > title
        super.UpdateFromData();

        // console.log("itemLayoutData=",this.itemLayoutData, "itemThemeData=",this.itemThemeData, "itemLocData=",this.itemLocData, "itemLiveData=",this.itemLiveData);

        const toggleGroupItemsCount = this.toggleGroup.GetLength();
        const newItemCount = this.itemLocData.choices.length;
        const selectItemIndex: number = this.itemLiveData.value as number;
        let item: OptionsLeafPopupTextItem;

        // need more items
        if (newItemCount > toggleGroupItemsCount) {
            for (let i: number = toggleGroupItemsCount; i < newItemCount; i++) {
                // create some more items
                item = this.GetFromPoolOrNew();
                this.toggleGroup.AddItem(item);
                // this.add(item);
                this.content.add(item);
            }
        }
        else
            if (newItemCount < toggleGroupItemsCount) {
                // pool extra items
                for (let i: number = newItemCount; i < toggleGroupItemsCount; i++) {
                    // create some more items
                    item = this.toggleGroup.RemoveLast() as OptionsLeafPopupTextItem;
                    // Phaser.Utils.Array.Remove(this.items, toggle);
                    this.remove(item);
                    item.SetSelected(false); // reset item (TODO: test)
                    AppObjectPool.DropObject(item, this.itemPoolGroupKey);
                }
            }

        // select proper item by index
        if (selectItemIndex < this.toggleGroup.GetLength()) {
            this.toggleGroup.SelectItemByIndex(selectItemIndex);
        }

        // UpdateFromLocalizationChange
        this.UpdateFromLocalizationChange();
    }

    public UpdateFromLocalizationChange(): void {
        this.toggleGroup.GetItems().forEach((item: OptionsLeafPopupTextItem, i) => {
            const itemText = this.itemLocData.choices[i].itemLabel as string;
            item.SetLabel(itemText);
        });
    }

    protected GetFromPoolOrNew(): OptionsLeafPopupTextItem {
        let item: OptionsLeafPopupTextItem = AppObjectPool.PickObject(this.itemPoolGroupKey);
        if (item == null) {
            item = new OptionsLeafPopupTextItem(this.scene);
            item.InitBase({
                out: { texture: LoaderFileKeys.ui, frame: "rect-2x2-transparent.png" },
                // out:{texture:LoaderFileKeys.ui, frame:"results-listItem-bg.png"},
                // over:{texture:LoaderFileKeys.ui, frame:"results-listItem-bg.png"},
                // disabled:{texture:LoaderFileKeys.ui, frame:"results-listItem-bg.png"},
            }, true);
            item.InitToggle({
                out: { texture: LoaderFileKeys.ui, frame: "rect-2x2-transparent.png" },
            }, false); // isSelected?
            // item.SetProps(20); // margin btwn icon and label
            item.InitIcon({
                out: { texture: LoaderFileKeys.ui, frame: "rect-2x2-transparent.png" },
                over: { texture: LoaderFileKeys.ui, frame: "icon-tick.png" },
            }, new Phaser.Geom.Point()); // cache iconPosition; later update it via item;s SetWidthGetHeight
            item.InitLabel(
                // labelText
                this.scene.make.text({
                    style: {
                        color: AppSettings.colors.whiteString,
                        fontSize: "80px",
                        fontFamily: AppSettings.fontFamilies.MontserratBold,
                        metrics: AppSettings.metrics.montserratBold80,
                    }
                }).setOrigin(0, 0.5),
                // selectedLabel
                undefined,
                // deselectedLabel
                undefined,
                // labelOffset
                new Phaser.Geom.Point(), // cache
                // selectedTextStyle
                {
                    color: AppSettings.colors.yellowString,
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    fontSize: "80px",
                    metrics: AppSettings.metrics.montserratBold80,
                },
                // deselectedTextStyle
                {
                    color: AppSettings.colors.whiteString,
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    fontSize: "80px",
                    metrics: AppSettings.metrics.montserratBold80,
                }
            );
            item.PostInit();
            this.add(item);
        }
        return item;
    }

    public override RegisterListeners(): void {
        super.RegisterListeners();
        this.toggleGroup.GetEventEmitter().on(ToggleGroupEvents.ITEM_SELECTED, this.OnListItemSelected, this);
    }

    public override UnregisterListeners(): void {
        super.UnregisterListeners();
        this.toggleGroup.GetEventEmitter().off(ToggleGroupEvents.ITEM_SELECTED, this.OnListItemSelected, this);
    }

    protected override OnListItemSelected(eventData: ToggleGroupItemSelectedEventData): void {
        // console.log("item selected:",eventData.itemIndex);

        // change live data index
        // const selectedItemIndex = this.toggleGroup.GetSelectedItemIndex();
        const selectedItemIndex = eventData.itemIndex;
        // CHANGE LIVE HERE?
        this.itemLiveData.value = selectedItemIndex;

        /**
         * call back to parent 
         */
        this.onListItemSelected?.(selectedItemIndex);
    }

    public SetInnerScale(innerScale: number): void {
        // console.log("SetInnerScale");

        // > title
        super.SetInnerScale(innerScale);

        this.itemSpacing.Set(
            this.itemSpacingBase.width * innerScale,
            this.itemSpacingBase.height * innerScale,
        );
    }

    /**
     * @alike: @see OnResize
     * 
     * NOTE: Content is bottom-right aligned
     * @param size 
     */
    public override SetSize(width: number, height: number): void {
        // console.log("SetSize",size);

        // > bg black A80 overlay (spans whole size)
        super.SetSize(width, height);

        // let nextPosY = this.borderPadding.top + this.titlePadding.top + this.btnBack.label.displayHeight * this.btnBack.scaleY + this.titlePadding.bottom;
        const overlayWidth = width - this.borderPadding.left - this.borderPadding.right;
        // const overlayHeight = height - this.borderPadding.top - this.titlePadding.top - this.title.displayHeight - this.titlePadding.bottom - this.borderPadding.bottom;
        const overlayHeight = height - this.borderPadding.top - this.titlePadding.top - this.btnBack.label.displayHeight * this.btnBack.scaleY - this.titlePadding.bottom - this.borderPadding.bottom;

        const inverseInnerScale = 1 / this.innerScale;

        const numItems = this.toggleGroup.GetLength();
        if (numItems) {
            // const itemHeight = (this.toggleGroup.GetItemByIndex(0) as OptionsLeafPopupTextItem).SetWidthGetHeight(this.size.width * inverseInnerScale) * this.innerScale;
            // console.log(":",this.content.x, this.content.y);
            let itemHeight = 0;
            this.toggleGroup.GetItems().forEach((item: OptionsLeafPopupTextItem, i) => {
                // for each item: set width (sets icon pos)
                itemHeight = item.SetWidthGetHeight(this.size.width * inverseInnerScale) * this.innerScale;
                // console.log(itemHeight);
                item.scale = this.innerScale;
                item.setPosition(
                    this.borderPadding.left,
                    // nextPosY + i * (itemHeight + this.itemSpacing.height)
                    i * (itemHeight + this.itemSpacing.height)
                );
                // console.log(item.x, item.y);
            });
            // content: height ONLY (based on items/content height)
            this.content.GetSize().height = numItems * (itemHeight * this.innerScale + this.itemSpacing.height) - this.itemSpacing.height;
        }
        // contentMask size
        this.contentMask.SetMaskRectSize(overlayWidth, overlayHeight);
        // > lastScrollDelta 0 an update scroll
        this.UpdateInPlace();
    }
}